import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Proveedores",
    items: [
      { label: "Compras",                     icon: "fas fa-money-check-alt",     href: "/ListadoComprasCXP",                  perm: "menu_adminCxP" },
      { label: "Abonos Proveedores",          icon: "fas fa-dollar-sign",         href: "/ListadoAbonosProveedores",           perm: "menu_adminCxP" },
      { label: "Estado Cuenta Proveedores",   icon: "fas fa-file-invoice-dollar", href: "/EstadoCuentaCXP",                    perm: "menu_adminCxP" },
      { label: "Devoluciones",                icon: "fas fa-undo-alt",            href: "/ListadoDevolucionesProveedoresAdmin", perm: "menu_adminCxP" },
    ],
  },
  {
    title: "Maquileros",
    items: [
      { label: "Notas Maquileros",          icon: "fas fa-money-check-alt",     href: "/ListadoNotasCxP",            perm: "menu_adminCxP" },
      { label: "Abonos Maquileros",         icon: "fas fa-dollar-sign",         href: "/ListadoAbonosMaquileros",    perm: "menu_adminCxP" },
      { label: "Estado Cuenta Maquileros",  icon: "fas fa-file-invoice-dollar", href: "/EstadoCuentaMaq",            perm: "menu_adminCxP" },
      { label: "Anticipos Maquileros",      icon: "fas fa-dollar-sign",         href: "/ListadoAnticiposProveedores", perm: "menu_adminCxP" },
      { label: "Aplicar Faltantes",         icon: "fas fa-dollar-sign",         href: "/ListadoFaltantesProveedores", perm: "menu_adminCxP" },
    ],
  },
];

function BotonesCXP() {
  return (
    <MenuGrid
      title="CxP"
      subtitle="Cuentas por pagar a proveedores y maquileros"
      icon="fas fa-money-check-alt"
      accent={{ color: "#f43f5e", bg: "#fff1f2" }}
      gate="menu_adminCxP"
      sections={SECTIONS}
    />
  );
}

export default BotonesCXP;
